import {useTranslation} from "react-i18next";
import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import React from "react";
import Collapsable from "../../common/Collapsable/Collapsable";

function EccServiceSettings(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        style,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.eccSettings')}
                           style={style} isDisabled={isDisabled}
        >
            <div className="settings-table">
                <div className="table-row-group">
                    <SettingsRowValue label={t('thirdPartyService:label.url')}
                                      value={thirdPartyService.url} isDisabled={isDisabled}/>
                </div>
            </div>
        </Collapsable>
    )
}

export default EccServiceSettings;